<button class="hud-icon-button" style="width: 100%; height: 100%; cursor: pointer">
  <app-style-sheet-sprite [sprite]="_stylesService.SPRITE_BUTTON_PRIMARY_ROUND()?.container">
    <div style="width: 100%; height: 100%; padding: 20%">
      @let __icon = _icon();
      @switch (__icon.type) {
        @case ('img') {
          <img [src]="__icon.url" alt="" />
        }
        @case ('sprite') {
          <app-style-sheet-sprite [sprite]="__icon.sprite" />
        }
      }
    </div>
  </app-style-sheet-sprite>
</button>
